<template>
  <div class="app-header">
    <div class="app-logo-wrapper">
      <div class="app-logo"></div>
    </div>
    <div class="app-actions">
      <div class="app-search">
        <div class="search-input">
          <el-autocomplete v-model="secCode" :fetch-suggestions="querySearchAsync"
            :placeholder="$t('common.tim_ma_chung_khoan')" @select="handleSelect">
            <template #suffix>
              <i class="ri-search-2-line"></i>
            </template>
            <template #default="{ item }">
              <span class="link">{{ item.name }}</span>
            </template>
          </el-autocomplete>
        </div>
      </div>
      <div class="app-toolbar">
        <div id="clock" class="toolbar-item">
          <div class="clock">
            <DigitalClock />
          </div>
        </div>
        <div id="connected" class="toolbar-item">
          <div v-if="isOnLine" class="wifi-on">
            <i class="ri-wifi-fill"></i>
          </div>
          <div v-else class="wifi-off"><i class="ri-wifi-off-fill"></i></div>
        </div>
        <div v-if="!requireLogin" class="toolbar-item">
          <el-badge v-if="unRead > 0" @click="showNotification()" :value="unRead" :max="99" class="item">
            <i class="ri-notification-3-line"></i>
          </el-badge>
          <div v-else @click="showNotification()">
            <i class="ri-notification-3-line"></i>
          </div>
        </div>
        <div class="user-login">
          <el-popover :width="260" trigger="click" popper-class="user-popover" :hide-after="0">
            <template #reference>
              <a lass="dropMenuBtn">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_639_29436)">
                    <path
                      d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                      fill="#6E99EE" />
                    <path
                      d="M20.0003 36.2602C27.7789 36.2602 34.0846 32.6202 34.0846 28.1301C34.0846 23.64 27.7789 20 20.0003 20C12.2218 20 5.91602 23.64 5.91602 28.1301C5.91602 32.6202 12.2218 36.2602 20.0003 36.2602Z"
                      fill="#EDEFF1" />
                    <path
                      d="M20.0002 20.0004C24.4903 20.0004 28.1303 16.3604 28.1303 11.8703C28.1303 7.3802 24.4903 3.74023 20.0002 3.74023C15.5101 3.74023 11.8701 7.3802 11.8701 11.8703C11.8701 16.3604 15.5101 20.0004 20.0002 20.0004Z"
                      fill="#EDEFF1" />
                    <path
                      d="M19.9996 29.7561L26.5617 21.3789C24.5547 20.4925 22.3347 20 19.9996 20C17.6645 20 15.4446 20.4925 13.4375 21.3789L19.9996 29.7561Z"
                      fill="#D3D3D3" />
                  </g>
                  <defs>
                    <clipPath id="clip0_639_29436">
                      <rect width="40" height="40" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </template>
            <template #default>
              <div id="userMenu" class="user-menu">
                <div class="account">
                  <div class="account-avatar">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_639_29436)">
                        <path
                          d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                          fill="#6E99EE" />
                        <path
                          d="M20.0003 36.2602C27.7789 36.2602 34.0846 32.6202 34.0846 28.1301C34.0846 23.64 27.7789 20 20.0003 20C12.2218 20 5.91602 23.64 5.91602 28.1301C5.91602 32.6202 12.2218 36.2602 20.0003 36.2602Z"
                          fill="#EDEFF1" />
                        <path
                          d="M20.0002 20.0004C24.4903 20.0004 28.1303 16.3604 28.1303 11.8703C28.1303 7.3802 24.4903 3.74023 20.0002 3.74023C15.5101 3.74023 11.8701 7.3802 11.8701 11.8703C11.8701 16.3604 15.5101 20.0004 20.0002 20.0004Z"
                          fill="#EDEFF1" />
                        <path
                          d="M19.9996 29.7561L26.5617 21.3789C24.5547 20.4925 22.3347 20 19.9996 20C17.6645 20 15.4446 20.4925 13.4375 21.3789L19.9996 29.7561Z"
                          fill="#D3D3D3" />
                      </g>
                      <defs>
                        <clipPath id="clip0_639_29436">
                          <rect width="40" height="40" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div v-if="userId != null && userId !== ''" class="account-info">
                    <span class="account-name">{{ this.fullName }}</span>
                    <span class="account-id"><span>{{ $t("common.tai_khoan") }}: </span><span>{{ this.userId
                        }}</span></span>
                  </div>
                  <div v-else class="account-info">
                    <span class="account-login"><a @click="login()">{{ $t("common.dang_nhap") }}</a></span>
                  </div>
                </div>
                <div class="menu-theme">
                  <div class="menu-title">{{ $t("common.chon_giao_dien") }}</div>
                  <ul>
                    <li v-if="role == 'vip'" @click="selectTheme('premium')">
                      <div>
                        <i class="ri-vip-diamond-line"></i><span>{{ $t("common.giao_dien_premium") }}</span>
                      </div>
                      <label class="radio-button">
                        <input v-model="theme" value="premium" type="radio" />
                        <span class="helping-el"></span>
                        <span class="label-text"></span>
                      </label>
                    </li>
                    <li @click="selectTheme('light')">
                      <div>
                        <i class="ri-sun-line"></i><span>{{ $t("common.giao_dien_sang") }}</span>
                      </div>
                      <label class="radio-button">
                        <input v-model="theme" value="light" type="radio" />
                        <span class="helping-el"></span>
                        <span class="label-text"></span>
                      </label>
                    </li>
                    <li @click="selectTheme('dark')">
                      <div>
                        <i class="ri-moon-clear-line"></i><span>{{ $t("common.giao_dien_toi") }}</span>
                      </div>
                      <label class="radio-button">
                        <input v-model="theme" value="dark" type="radio" />
                        <span class="helping-el"></span>
                        <span class="label-text"></span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="menu-languages">
                  <div class="menu-title">{{ $t("common.chon_ngon_ngu") }}</div>
                  <ul>
                    <li @click.prevent="setLanguage('vi')">
                      <div>
                        <img src="../../assets/images/vn.svg" /><span>{{
            $t("langs.tieng_viet")
          }}</span>
                      </div>
                      <label class="radio-button">
                        <input v-model="lang" value="vi" type="radio" />
                        <span class="helping-el"></span>
                        <span class="label-text"></span>
                      </label>
                    </li>
                    <li @click.prevent="setLanguage('en')">
                      <div>
                        <img src="../../assets/images/en.svg" /><span>{{
            $t("langs.tieng_anh")
          }}</span>
                      </div>
                      <label class="radio-button">
                        <input v-model="lang" value="en" type="radio" />
                        <span class="helping-el"></span>
                        <span class="label-text"></span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div v-if="userId != null && userId !== ''" class="menu-logout">
                  <a @click="logout()"><i class="ri-logout-box-r-line"></i> {{ $t("common.dang_xuat_tai_khoan") }}</a>
                </div>
              </div>
            </template>
          </el-popover>
        </div>
      </div>
    </div>
    <el-drawer append-to-body v-model="drawer" :title="$t('common.tin_hieu_canh_bao')" direction="rtl">
      <Notify :data="notifyList" />
    </el-drawer>
  </div>
</template>

<script>
import { TokenService } from "../../api/storageService";
import authService from '@/api/authService';
import DigitalClock from "../DigitalClock.vue";
import i18n from "../../lang/i18n";
import Notify from "./Notify.vue";
import { mapActions } from "vuex";
import common from "../../mixins/index";
import { APP_CONFIG } from "@/contants";
import commonService from "@/api/commonService";
import notifyService from '@/api/notifyService';
import { uuid } from 'vue-uuid';
import messageBox from "../../utils/messageBox"
import axios from "axios";
import Cookies from 'js-cookie';

export default {
  components: {
    Notify,
    DigitalClock,
  },
  data() {
    return {
      theme: common.theme.dark,
      drawer: false,
      radio: "accent",
      lang: common.langs.vietnam,
      loadding: false,
      showNotify: false,
      isOnLine: navigator.onLine,
      fullName: "",
      userId: "",
      role: "normal",
      stocks: [],
      secCode: "",
      state: uuid.v1(),
      notifyList: [],
      lastSeen: '',
      unRead: 0,
      requireLogin: true,
    };
  },
  mounted() {
    if (TokenService.getUserId() != null && TokenService.getUserId() !== '') {
      console.log('start connect to socket notify')
      this.socket = new WebSocket(APP_CONFIG.socketUrl);

      this.socket.onmessage = (event) => {
        this.updateRealTime(event.data);
      };
      this.socket.onopen = function (event) {
        console.log('connected socket notify');
        //this.send(JSON.stringify({ "event": "subscribe", "channel": 'REALTIME_SIGNAL_0001007649' }));
        this.send(JSON.stringify({ "event": "subscribe", "channel": 'REALTIME_SIGNAL_' + TokenService.getUserId() }));
      }
      this.socket.onclose = function () {
        console.log('closed socket REALTIME_SIGNAL');
      }
    }
  },
  unmounted() {
    if (this.socket != null) {
      this.socket.close();
    }

    this.socket = null;
    console.log("Closing connection to WebSocket Server")
  },
  async created() {
    //TokenService.saveMd5("609571E1B3778EC51503F5E30DE5A38D");
    //TokenService.saveUserId("0001010250");
    //TokenService.saveUserName("032C009665");
    //TokenService.saveUser("ASEANSC");
    //TokenService.saveRole("vip");
    this.role = TokenService.getRole();
    this.fullName = TokenService.getUser();
    this.userId = TokenService.getUserId();
    this.getSecListAll();
    this.secCode = this.$route.query.secCode;
    if (this.userId != null && this.userId !== '') {
      const permission = await this.checkPermission();
      this.requireLogin = permission.requireLogin;
      
      if(!permission.requireLogin){
          this.getNotifyByUser();
      }
    }
  },
  methods: {
    ...mapActions("common", ["setLang", "setTheme", "setLogout"]),

    showNotification() {
      this.drawer = true;
      this.setLastSeen();
    },

    updateRealTime(item) {
      const obj = JSON.parse(item);
      const index = this.notifyList.findIndex((item) => item.securityCode === obj.SecurityCode && item.time === obj.Time && item.realtimeFormulaId === obj.RealtimeFormulaId && item.buySellInd === obj.BuySellInd);
      if (index == -1) {
        this.unRead += 1;
        let newNotify = { userId: obj.UserId, time: obj.Time, securityCode: obj.SecurityCode, buySellInd: obj.BuySellInd, realtimeFormulaId: obj.RealtimeFormulaId }
        this.notifyList.unshift(newNotify);
        this.notifyList = this.notifyList.sort(function (a, b) {
          return b.time.localeCompare(a.time);
        });
      }
    },

    setLastSeen() {
      notifyService.setUserLastSeenNoti().then((response) => {
        this.unRead = 0;
      }).finally(() => { this.loadding = false; });
    },

    getNotifyByUser() {
      this.loadding = true;
      notifyService.getNotifyByUser().then((response) => {
        if (response.status == 200) {
          this.notifyList = response.data.signals;
          this.lastSeen = response.data.lastSeen;
          this.unRead = response.data.unSeen;
        }
        else {
          messageBox.showWarning(response.message);
        }
      }).finally(() => { this.loadding = false; });
    },


    handleSelect(item) {
        this.$router.replace({
            name: "enterprise",
            query: { secCode: item.code },
        });
    },

    querySearchAsync(queryString, cb) {
      var stocks = this.stocks;
      var results = queryString
        ? stocks.filter(this.createFilter(queryString))
        : stocks;
      cb(results);
    },

    createFilter(queryString) {
      return (stock) => {
        return (
          stock.code.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },

    getSecListAll() {
      this.loadding = true;
      commonService
        .getSecListAll(this.lang)
        .then((response) => {
          if (response.status == 200) {
            this.stocks = response.data;
          } else {
            messageBox.showWarning("Có lỗi xẩy ra");
          }
        })
        .finally(() => {
          this.loadding = false;
        });
    },

    setLanguage(lang) {
      i18n.global.locale.value = lang;
      TokenService.saveLang(lang);
      this.lang = lang;
      this.setLang(lang);
    },

    selectTheme(theme) {
      this.theme = theme;
      document.querySelector("html").className = theme;
      this.$emit(theme);
      TokenService.saveTheme(theme);
      this.setTheme(theme);
    },

    openMenu() {
      document.getElementById("userMenu").classList.toggle("show");
    },

    async logout() {
      const data = { x_token: TokenService.getMd5() }
      authService.logout(data).then((response) => {
          this.setLogout();
          this.fullName = "";
          this.userId = null;
          const theme = 'dark';
          TokenService.saveRole('normal');
          TokenService.saveTheme(theme);
          document.querySelector("html").className = theme;
          this.$emit(theme);
          this.setTheme(theme);
          messageBox.showMessage("Logout thành công");
          window.location.href = APP_CONFIG.ssoUrl + '/sso/logout?returnTo=' + APP_CONFIG.webUrl;
      }).finally(() => { this.loadding = false; });
    },

    login() {
      this.state = uuid.v1();
      let url =
        APP_CONFIG.ssoUrl +
        "/sso/oauth/authorize?client_id=" +
        APP_CONFIG.ssoClientId +
        "&response_type=code&redirect_uri=" +
        APP_CONFIG.webUrl +
        "/callback&scope=general&state=" +
        this.state +
        "&ui_locales=vi&loginWithAnother=true&webtrade=true&language=vi&name=&username=&theme=dark";

         window.location.href = url;
    },
  },
  mounted() {

    this.theme =
      TokenService.getTheme() == null ? common.theme.dark : TokenService.getTheme();
    this.lang = TokenService.getLang() == null ? common.langs.vietnam : TokenService.getLang();
    window.addEventListener("online", () => {
      this.isOnLine = true;
    });
    window.addEventListener("offline", () => {
      this.isOnLine = false;
    });
  },
  watch: {
    "$route.query.secCode": function () {
      this.secCode = this.$route.query.secCode;
    },
  },
};
</script>

<style>
.el-badge {
  padding-right: 20px;
}

.el-badge__content.is-fixed {
  top: 10px;
  left: -11px;
  width: 30px;
}

.account-login a {
  color: var(--color-primary);
  font-weight: bold !important;
  text-decoration: underline !important;
}
</style>
<style scoped>
.app-search {
  max-width: 500px;
  flex-grow: 1;
}

#connected {
  padding-right: 10px;
}

#connected i {
  font-size: 16px;
}

.wifi-on i {
  color: rgb(0, 244, 176);
}

.wifi-off i {
  color: var(--text-color);
}

.app-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-grow: 2;
}

.app-logo-wrapper {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
}

@media only screen and (max-width: 768px) {
  .app-sidebar {
    display: none;
  }

  #clock {
    display: none;
  }

  .m-sidebar {
    display: block;
  }

  .app-header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    height: fit-content;
  }

  .app-logo-wrapper {
    justify-content: center;
  }

  .app-logo {
    min-height: 30px;
  }

  .app-actions {
    width: 100%;
    padding: 0 10px;
  }
}
</style>
